<template>
  <a :href="recipe.url" class="recipe-preview">
    <div>
      <figure class="image is-square">
        <responsive-image :desktop="recipe.desktop_image" :tablet="recipe.tablet_image" :mobile="recipe.mobile_image" :blurred="recipe.blurred_image" lazy/>
        <div class="overlay">
          <div class="top-left" v-if="time"><i class="fa fa-clock-o"/> {{time}}</div>
          <div class="top-right" v-if="recipe.video_url">
            <span><i class="fa fa-youtube-play"/></span>
          </div>
        </div>
      </figure>
    </div>
    <div class="info" :style="{'background-color': recipe.image_color}">
      <h2 class="title">{{recipe.name}}</h2>
      <div class="tags">
        <span class="tag is-info" :style="{'background-color': difficultyColor}" v-if="recipe.difficulty && recipe.difficulty.difficulty">{{recipe.difficulty.difficulty}}</span>
        <span class="tag is-info" v-for="tag in recipe.nutrition_tags" :key="tag">{{$t(tag)}}</span>
      </div>
    </div>
  </a>
</template>

<script>
import ResponsiveImage from '../ResponsiveImage.vue'
import format from 'shared/lib/format'

export default {
  props: {
    recipe: {type: Object, default: () => ({})}
  },

  components: {
    ResponsiveImage
  },

  computed: {
    time(){
      if(!this.recipe.total_time) return
      return format.minutes(this.recipe.total_time)
    },

    difficultyColor(){
      const colors = ['#23d160', '#85d123', '#b5d123', '#d1c523', '#d1ad23']
      return colors[this.recipe.difficulty.id - 1]
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "low_carb": "low carb",
    "low_fat": "fettarm",
    "high_vitamin_a": "reich an Vit. A",
    "high_vitamin_c": "reich an Vit. C",
    "high_vitamin_e": "reich an Vit. E",
    "high_vitamin_k": "reich an Vit. K"
  },
  "en": {
    "low_carb": "low carb",
    "low_fat": "low fat",
    "high_vitamin_a": "rich on vit. A",
    "high_vitamin_c": "rich on vit. C",
    "high_vitamin_e": "rich on vit. E",
    "high_vitamin_k": "rich on vit. K"
  },
  "cs": {
    "low_carb": "low carb",
    "low_fat": "low fat",
    "high_vitamin_a": "rich on vit. A",
    "high_vitamin_c": "rich on vit. C",
    "high_vitamin_e": "rich on vit. E",
    "high_vitamin_k": "rich on vit. K"
  },
  "hu": {
    "low_carb": "low carb",
    "low_fat": "low fat",
    "high_vitamin_a": "rich on vit. A",
    "high_vitamin_c": "rich on vit. C",
    "high_vitamin_e": "rich on vit. E",
    "high_vitamin_k": "rich on vit. K"
  },
  "fr": {
    "low_carb": "low carb",
    "low_fat": "low fat",
    "high_vitamin_a": "rich on vit. A",
    "high_vitamin_c": "rich on vit. C",
    "high_vitamin_e": "rich on vit. E",
    "high_vitamin_k": "rich on vit. K"
  }
}
</i18n>

<style>

</style>



// WEBPACK FOOTER //
// src/components/recipe/Preview.vue